// import WidgetAjax from './../widget/WidgetAjax';

export default class Config {
    static getBasePath() {
        // const basePath = "http://192.168.0.147:8090/gradeIndividualAPI";
        // const basePath = "http://218.26.73.114:18121/gradeIndividualAPI";
        const basePath = "/gradeIndividualAPI";//注掉
        // 测试环境
        // const basePath = "http://121.52.209.242:23942/gradeIndividualAPI";
        // const basePath = "http://118.178.188.79/gradeIndividualAPI"

        return basePath;
    }

    static getTagBasePath() {
        // 测试环境
        //  const basePath = "http://121.52.209.242:23942/gradeIndividualAPI";
        // const basePath = "http://118.178.188.79/gradeIndividualAPI"

        // const basePath = "http://218.26.73.114:18121/gradeIndividualAPI";
        // const basePath = "http://192.168.0.147:8090/gradeIndividualAPI";
        const basePath = "/gradeIndividualAPI";//注掉

        return basePath;
    }

    static getThalassaPath() {

        // const basePath = "/gradeIndividualAPI";//注掉
        // 测试环境
        //  const basePath = "http://121.52.209.242:23942/gradeIndividualAPI";

        // const basePath = "http://218.26.73.114:18121/gradeIndividualAPI";

        return "";
    }

    static getFilePath() {

        // const basePath = "http://218.26.73.114:18121/grade-individualTest/static/attachment/";

        // 正式环境
        const basePath = "/grade-individual-app/static/attachment/";

        // 测试环境
        // const basePath = "http://121.52.209.242:23942/grade-individualTest/static/attachment/";

        return basePath;
    }

    static getDBID() {
        const DBID = undefined;
        return DBID;
    }

    static getMapName() {
        return "110105";
    }

    static getEncryptyType() {
        return "MD5";
    }

    static isShowHeaderArea() {
        return false;
    }

    static getSystemTitle() {
        return "全国“名特优新”个体工商户培育平台";
    }

    static getSystemType() {
        return "sso"; // 线上
        // return "local"; // 线下
    }

    static getHermesPanoramaUID() {
        return "yx";
    }
}


